exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect__tag {\n    position: relative;\n    display: inline-block;\n    padding: 4px 26px 4px 10px;\n    border-radius: 5px;\n    margin-right: 10px;\n    color: #fff;\n    line-height: 1;\n    background: #20a8d8;\n    margin-bottom: 5px;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n}\n.multiselect__option--highlight {\n    background: #20a8d8;\n    outline: none;\n    color: white;\n}\n.multiselect__option--highlight:after {\n    content: attr(data-select);\n    background: #20a8d8;\n    color: white;\n}\n", ""]);

// exports
